import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);        // दाखले
  const [teamOpen, setTeamOpen] = useState(false); // पदाधिकारी

  // Click outside dropdown बंद
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-wrapper')) {
        setOpen(false);
        setTeamOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <>
      {/* TOP BAR - Vibrant + Official */}
      <div className="top-bar">
        <div className="top-content">
          <span>ग्रामपंचायत कापशी | पंचायत समिती डहाणू, जि. पालघर</span>
          <a href="tel: 8805042257" className="service-no">
            Helpline no: 8805042257
          </a>
        </div>
      </div>

      {/* HEADER - Clean, Modern, Attractive */}
      <header className="header">
        <div className="header-inner">
          {/* LEFT - Logo + Title with animation */}
          <div className="header-left">
            <img 
              src="/images/sj1.jpg" 
              alt="राष्ट्रीय चिन्ह" 
              className="emblem" 
            />
            <div className="title-box">
              <h1>ग्रामपंचायत कापशी</h1>
              <h3>ISO 9001:2015 प्रमाणित</h3>
            </div>
          </div>

          {/* RIGHT - Personalities with enhanced glow & subtle animation */}
          <div className="header-right personalities">
            <div className="photo-group">
              {[
                "/images/raje.jpg",
                "/images/gandhiji.jpg",
                "/images/tujdojimaharaj.jpeg",
              ].map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt="महापुरुष"
                  className="personality-img glow-frame"
                  style={{ animationDelay: `${i * 0.2}s` }}
                />
              ))}
            </div>
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>

        {/* NAV BAR - 3D hover stronger + gradient */}
        <nav className={`nav-bar ${menuOpen ? "open" : ""}`}>
          <Link to="/" className="nav-item">मुख्य पृष्ठ</Link>
          <Link to="/aboutus" className="nav-item">ग्रामपंचायत-बद्दल</Link>

          <div className="dropdown-wrapper">
            <span onClick={() => setTeamOpen(!teamOpen)} className="nav-item">
              पदाधिकारी व सदस्य ▾
            </span>
            {teamOpen && (
              <div className="dropdown">
                <Link to="/sachiv">ग्रामपंचायत अधिकारी</Link>
                <Link to="/sarpanch">सरपंच</Link>
                <Link to="/team">सदस्य / कर्मचारी</Link>
              </div>
            )}
          </div>

          <div className="dropdown-wrapper">
            <span onClick={() => setOpen(!open)} className="nav-item">
              दाखले ▾
            </span>
            {open && (
              <div className="dropdown">
                <Link to="/janm-dakhala">जन्म दाखला</Link>
                <Link to="/mrut-dakhala">मृत्यू दाखला</Link>
                <Link to="/vivah-dakhala">विवाह दाखला</Link>
                <Link to="/namuna">नमुना ८</Link>
              </div>
            )}
          </div>

          <Link to="/devlopment" className="nav-item">विकास कामे</Link>
          <Link to="/gallery" className="nav-item">छायाचित्र</Link>
          <Link to="/contact" className="nav-item">संपर्क</Link>
        </nav>
      </header>

      <style>{`
        body {
          margin: 0;
          font-family: "Noto Sans Devanagari", sans-serif;
        }

        /* TOP BAR - Navy Blue */
        .top-bar {
          background: #001f3f;           /* Navy Blue */
          color: #ffffff;
          padding: 8px 0;
          font-weight: 600;
          font-size: 15px;
        }
        .top-content {
          max-width: 1300px;
          margin: auto;
          padding: 0 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        }
        .service-no {
          color: #a8daf9;               /* Light Blue - bright contrast */
          text-decoration: none;
          font-weight: 700;
          transition: color 0.3s;
        }
        .service-no:hover {
          color: #ffffff;
        }

        /* HEADER - White + subtle light blue gradient */
        .header {
          background: linear-gradient(to bottom, #ffffff, #f0f8ff);
          box-shadow: 0 4px 14px rgba(0,0,0,0.08);
          border-bottom: 4px solid #001f3f;   /* Navy border */
        }
        .header-inner {
          max-width: 1300px;
          margin: auto;
          padding: 18px 25px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        /* LEFT - Logo + Title */
        .header-left {
          display: flex;
          align-items: center;
          gap: 18px;
        }
        .emblem {
          height: 72px;
          transition: all 0.5s ease;
          animation: floatGentle 7s ease-in-out infinite;
        }
        .emblem:hover {
          transform: scale(1.1) rotate(10deg);
        }
        @keyframes floatGentle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        .title-box {
          background: linear-gradient(135deg, #001f3f, #004b8d); /* Navy gradient */
          color: #ffffff;
          padding: 12px 30px;
          border-radius: 12px;
          box-shadow: 0 6px 20px rgba(0, 31, 63, 0.3);
          text-align: center;
        }
        .title-box h1 {
          margin: 0;
          font-size: 27px;
          font-weight: 800;
          letter-spacing: 0.8px;
        }
        .title-box h3 {   /* h3 ला p ऐवजी h3 केलं कारण तुमच्या कोडमध्ये h3 आहे */
          margin: 6px 0 0;
          font-size: 14px;
          font-weight: 500;
        }

        /* RIGHT - Personalities - navy glow */
        .personalities .photo-group {
          display: flex;
          gap: 12px;
        }
        .personality-img {
          width: 62px;
          height: 62px;
          border-radius: 50%;
          border: 3px solid #001f3f;            /* Navy border */
          object-fit: cover;
          box-shadow: 
            0 0 14px #001f3f,
            0 0 24px #004b8d,
            0 10px 25px rgba(0, 0, 0, 0.2);
          transition: all 0.4s ease;
          animation: subtlePulse 4s infinite alternate;
        }
        .personality-img:hover {
          transform: scale(1.18);
          box-shadow: 
            0 0 30px #a8daf9,
            0 0 40px #4fc3f7,
            0 18px 35px rgba(0,0,0,0.3);
        }
        @keyframes subtlePulse {
          from { box-shadow: 0 0 14px #001f3f, 0 0 24px #004b8d; }
          to   { box-shadow: 0 0 20px #001f3f, 0 0 32px #004b8d; }
        }

        /* Hamburger */
        .hamburger {
          display: none;
          font-size: 32px;
          color: #001f3f;
          cursor: pointer;
        }

        /* NAV BAR - Light background + navy text */
        .nav-bar {
          background: #f0f8ff;                  /* Very light blue */
          padding: 12px 0;
          display: flex;
          justify-content: center;
          gap: 10px;
          flex-wrap: wrap;
          border-top: 1px solid #cce4ff;
        }
        .nav-item {
          color: #001f3f;                      /* Navy text */
          font-weight: 700;
          padding: 9px 18px;
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.3);
          position: relative;
        }
        .nav-item:hover {
          background: linear-gradient(135deg, #004b8d, #0077cc); /* Navy → medium blue */
          color: #ffffff;
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 15px 30px rgba(0, 75, 141, 0.35);
        }

        /* Dropdown */
        .dropdown-wrapper { position: relative; }
        .dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          background: #ffffff;
          border: 1px solid #cce4ff;           /* Light blue border */
          border-radius: 8px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          z-index: 1000;
          min-width: 220px;
          overflow: hidden;
        }
        .dropdown a {
          display: block;
          padding: 12px 20px;
          color: #001f3f;
          text-decoration: none;
          border-bottom: 1px solid #e6f0ff;
          transition: all 0.3s;
        }
        .dropdown a:hover {
          background: #e6f0ff;                 /* Very light blue hover */
          color: #004b8d;
          padding-left: 28px;
        }

        /* Mobile responsive */
        @media (max-width: 768px) {
          .personalities { display: none; }
          .hamburger { display: block; }
          .nav-bar {
            display: none;
            flex-direction: column;
            background: #ffffff;
            padding: 20px;
            box-shadow: 0 10px 20px rgba(0,0,0,0.1);
          }
          .nav-bar.open { display: flex; }
          .title-box h1 { font-size: 22px; }
          .emblem { height: 58px; }
          .header-inner { flex-wrap: wrap; }
        }
      `}</style>
    </>
  );
};

export default Header;